


















import { Component, Prop, Vue } from "vue-property-decorator";
@Component({})
export default class AppButtonAddRpa extends Vue {

  getRouteAdd() {
    this.$router.push({ name: "add-rpa" });
  }
}
